var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":'https://lurker.blob.core.windows.net/companies/d_comp_' + _vm.model.id + '.jpg'}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }